export const SITE = {
  name: "Long Horn Trailer Rentals",
  tagline: "Heavy-duty hauling, available 24/7 in Burlington, NC.",
  phone: "336-212-9147",
  phoneHref: "tel:+13362129147",
  email: "andresrm656@gmail.com",
  emailHref: "mailto:andresrm656@gmail.com",
  address: "Burlington, NC",
  bookingUrl: "http://longhorn.hqrent.com/",
  hours: "24/7 — scheduling & pick up",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_longhorn-rentals/artifacts/rxj5pkr9_IMG_1665.png",
  serviceArea: "Serving Burlington, NC & the Triad area",
};

export const TRAILERS = [
  {
    id: "car-hauler-20",
    name: "102\" x 20' Car Hauler",
    subtitle: "Drive-Over Fenders",
    capacity: "8,000 lbs",
    image:
      "https://customer-assets.emergentagent.com/job_longhorn-rentals/artifacts/1tsxpbod_IMG_1835.jpeg",
    fallback: "linear-gradient(135deg, #8B2332 0%, #1F1B16 100%)",
    rates: [
      { label: "Daily", price: "$120" },
      { label: "Weekly", price: "$500" },
      { label: "Monthly", price: "$1,500" },
    ],
    highlights: [
      "Drive-over fenders for easy loading",
      "12,000 lb winch with wireless remote",
      "Two adjustable slide-out ramps",
      "Straps + spare tire (full tire-changing kit)",
    ],
    spec: [
      ["Length", "20 ft"],
      ["Deck Width", "102 in"],
      ["Capacity", "8,000 lbs"],
      ["Ball Size", "2-5/16\""],
    ],
    note:
      "Need it for less than a day or a custom number of days? Call for pricing.",
  },
  {
    id: "car-hauler-16",
    name: "7' x 16' Car Hauler",
    subtitle: "Full Kit Included",
    capacity: "5,000 lbs",
    image:
      "https://customer-assets.emergentagent.com/job_longhorn-rentals/artifacts/52adea8u_IMG_1473.jpeg",
    fallback: "linear-gradient(135deg, #6E1A26 0%, #D4A24C 100%)",
    rates: [
      { label: "Daily", price: "$100" },
      { label: "Weekly", price: "$500" },
      { label: "Monthly", price: "$1,500" },
    ],
    highlights: [
      "Ramps, straps, winch and J-hooks",
      "Spare tire and lug wrench included",
      "Ball size: 2-5/16\"",
      "Available 24/7",
    ],
    spec: [
      ["Length", "16 ft"],
      ["Deck Width", "7 ft"],
      ["Capacity", "5,000 lbs"],
      ["Ball Size", "2-5/16\""],
    ],
    note: "Message to confirm availability — scheduling is open 24/7.",
  },
  {
    id: "utility-14",
    name: "7' x 14' Utility Trailer",
    subtitle: "Hauling & Moving",
    capacity: "3,000 lbs",
    image:
      "https://customer-assets.emergentagent.com/job_longhorn-rentals/artifacts/g09fs8fc_IMG_1472.jpeg",
    fallback: "linear-gradient(135deg, #1F1B16 0%, #8B2332 100%)",
    rates: [
      { label: "Daily", price: "$60" },
      { label: "Weekly", price: "$250" },
      { label: "Monthly", price: "$700" },
    ],
    highlights: [
      "Spare tire and tool box on board",
      "Straps, bottle jack & 4-way lug wrench",
      "Delivery available — hitch can be provided",
      "Great for junk hauls, moving & yard debris",
    ],
    spec: [
      ["Length", "14 ft"],
      ["Deck Width", "7 ft"],
      ["Capacity", "3,000 lbs"],
      ["Ball Size", "2\" 5/16"],
    ],
    note: "Renters must provide a valid ID and proof of insurance.",
  },
  {
    id: "dump-14",
    name: "7' x 14' Dump Trailer",
    subtitle: "Hydraulic Dump Bed",
    capacity: "9,000 lbs",
    image: "/trailers/dump-trailer.jpg",
    fallback: "linear-gradient(135deg, #8B2332 0%, #D4A24C 100%)",
    rates: [
      { label: "Daily", price: "$140" },
      { label: "Weekly", price: "$700" },
      { label: "Monthly", price: "$1,500" },
    ],
    highlights: [
      "Hydraulic dump for fast unloading",
      "Ramps included for equipment loading",
      "Spare tire on board",
      "Heavy-duty 9,000 lb capacity",
    ],
    spec: [
      ["Length", "14 ft"],
      ["Deck Width", "7 ft"],
      ["Capacity", "9,000 lbs"],
      ["Ball Size", "2-5/16\""],
    ],
    note: "Great for dirt, gravel, mulch, demo debris & scrap hauls.",
  },
];

export const REQUIREMENTS = [
  {
    title: "Valid Driver's License",
    body: "A current driver's license from any U.S. state is required at pick up.",
  },
  {
    title: "Proof of Insurance",
    body: "Auto insurance covering the tow vehicle must be presented before release.",
  },
  {
    title: "Correct Tow Setup",
    body: "Make sure your hitch ball matches the trailer (2\" 5/16 for utility / 2-5/16\" for car haulers). We can supply a hitch on request.",
  },
  {
    title: "Available 24/7",
    body: "Scheduling, pick up and drop off — any day of the week, any hour. Just give us a call.",
  },
];
